<template>
  <van-popup class="vg-popup"
             v-bind="$attrs"
             v-on="$listeners">
    <template>
      <slot></slot>
    </template>
  </van-popup>
</template>

<script>
import {Popup} from "vant";

export default {
  name: "VgPopup",
  components: {
    "van-popup": Popup,
  },
}
</script>

<style scoped>
</style>
